export const APP_VERSION =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "0.0.0-dev";
export const BUILD_TIME_ISO =
  typeof __BUILD_TIME__ !== "undefined" ? __BUILD_TIME__ : new Date(0).toISOString();
export const BUILD_CHANNEL =
  typeof __BUILD_CHANNEL__ !== "undefined" ? __BUILD_CHANNEL__ : "development";
export const SENTRY_RELEASE =
  typeof __SENTRY_RELEASE__ !== "undefined"
    ? __SENTRY_RELEASE__
    : `${APP_VERSION}-${BUILD_CHANNEL}`;
export const TELEMETRY_EVENT_VERSION = 2;

export function formatBuildLabel(): string {
  return `v${APP_VERSION}`;
}

export function formatBuildTime(): string {
  const parsedTime = Date.parse(BUILD_TIME_ISO);
  if (Number.isNaN(parsedTime)) {
    return BUILD_TIME_ISO;
  }

  return new Date(parsedTime).toLocaleString();
}
